"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Load = exports.Env = void 0;
const validator_1 = require("@leavy/validator");
const loader_1 = require("./loader");
const Env = (key) => {
    return (target, propertyKey) => {
        if (key in process.env && process.env[key] !== undefined) {
            validator_1.Expose({ name: key })(target, propertyKey);
        }
    };
};
exports.Env = Env;
const Load = (cls) => {
    return (target, propertyKey) => {
        validator_1.Expose()(target, propertyKey);
        validator_1.Transform(() => loader_1.loadConfig(cls))(target, propertyKey);
    };
};
exports.Load = Load;
//# sourceMappingURL=decorators.js.map